import { useEffect } from 'react'

export const useEscapeKey = (onEscape: () => void, listen = true) => {
  useEffect(() => {
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onEscape()
      }
    }

    if (listen) {
      document.addEventListener('keydown', keyHandler)
    } else {
      document.removeEventListener('keydown', keyHandler)
    }

    return () => {
      document.removeEventListener('keydown', keyHandler)
    }
  }, [onEscape, listen])
}
